module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/kansas-state-university-39814749755ea2da3dd73c4ec3009f85.svg";